<template>
	<v-dialog v-model="dialog" persistent max-width="500">
		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">回答の編集</v-toolbar-title>
			</v-toolbar>
			<v-card-text class="py-2">
				<p v-if="answer.user_id != user.id" class="red--text">他の人が作成した回答です</p>
				<p v-if="answer.status_id != 'draft'" class="red--text">
					この回答は既に発行済みです。<br />必要に応じて更新前に関係者と調整を行い、更新後に関係者に別途連絡を入れてください。<br />更新後に履歴が作成されます。
				</p>
				<v-divider class="my-2" v-if="answer.status_id != 'draft'" />
				<p>現在の値：{{ common.value(answerColumn, value.value) }}</p>
			</v-card-text>
			<v-form v-model="valid" ref="form">
				<v-card-actions class="d-block">
					<v-text-field
						:label="answerColumn.name"
						dense
						outlined
						:rules="[]"
						class="mt-4"
						v-model="newValue"
						v-if="
							answerColumn.data_type == 'url' ||
							answerColumn.data_type == 'feature' ||
							answerColumn.data_type == 'string'
						"
					/>
					<v-textarea
						:label="answerColumn.name"
						dense
						outlined
						:rules="[]"
						class="mt-4"
						v-model="newValue"
						v-if="answerColumn.data_type == 'text'"
					/>
					<v-text-field
						:label="answerColumn.name"
						type="date"
						dense
						outlined
						:rules="[]"
						class="mt-4"
						v-model="newValue"
						v-else-if="answerColumn.data_type == 'date'"
					/>
					<div class="mt-4" v-else-if="answerColumn.data_type == 'boolean'">
						<v-row no-gutters class="mt-1 checkbox-wrapper">
							<v-checkbox
								v-model="newValue"
								:label="answerColumn.name"
								:rules="[]"
								class="mr-2"
								dense
							/>
						</v-row>
					</div>
					<v-text-field
						:label="answerColumn.name"
						type="number"
						dense
						outlined
						:rules="rules['integerRules']"
						class="mt-4"
						v-model="newValue"
						v-else-if="answerColumn.data_type == 'integer'"
					/>
					<v-text-field
						:label="answerColumn.name"
						type="number"
						dense
						outlined
						step="0.01"
						:rules="floatRules"
						class="mt-4"
						v-model="newValue"
						v-else-if="answerColumn.data_type == 'float'"
					/>
					<v-select
						:label="answerColumn.name"
						:items="answerColumn.answer_column_options"
						item-text="text"
						item-value="text"
						hint="選択してください"
						no-data-text="選択肢ががありません"
						class="mt-4"
						dense
						outlined
						v-model="newValue"
						v-else-if="answerColumn.data_type == 'option'"
					/>
					<AssociationSelectDialog
						v-else-if="answerColumn.data_type == 'target'"
						:value.sync="newTargetValue"
						:label="answerColumn.name"
						:association_value.sync="newTargetValue.name"
						:type="'value_target_type'"
						:id="'value_target_id'"
						:associationName="answerColumn.association_name"
					/>
					<template
						v-if="answerColumn.data_type == 'synchronization' && answerColumn.data_synchronization"
					>
						<SynchronizationForm
							:id="synchronizationModelId()"
							:is_draft="!!value.value.synchronized_datum"
							:column="answerColumn"
							:value.sync="newSynchronizationValue.synchronized_data"
							:display_value.sync="newSynchronizationValue.display_value"
							@cancel-target="newSynchronizationValue.new_data = true"
						/>
						<p v-if="newSynchronizationValue.synchronized_data.skip" class="text-body-2">
							データが変更されていません。
						</p>
						<p
							v-else-if="!!value.value.synchronized_datum && newSynchronizationValue.new_data"
							class="text-body-2"
						>
							既に作成されたデータは削除されません。
						</p>
					</template>
				</v-card-actions>
				<v-card-actions>
					<v-textarea
						class="mt-4"
						label="変更理由"
						:rules="[rules.required]"
						outlined
						dense
						v-model="reason"
						v-if="answer.status_id != 'draft'"
					/>
				</v-card-actions>
				<v-card-actions>
					<v-row no-gutters>
						<v-col cols="4" />
						<v-col cols="4">
							<v-row no-gutters justify="center">
								<v-btn color="secondary" @click="choiceUpdate" :disabled="!valid">
									<v-icon class="mr-2">mdi-arrow-up-bold-box-outline</v-icon>
									更新する
								</v-btn>
							</v-row>
						</v-col>

						<v-col cols="4">
							<v-row no-gutters justify="end">
								<v-btn color="grey darken-1" text @click="closeDialog"> 閉じる </v-btn>
							</v-row>
						</v-col>
					</v-row>
				</v-card-actions>
			</v-form>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import common from "../../../helper/common"
import rules from "../../../helper/rules"
import AssociationSelectDialog from "../../shared/AssociationSelectDialog.vue"
import SynchronizationForm from "../../shared/SynchronizationForm.vue"

export default {
	components: {
		AssociationSelectDialog,
		SynchronizationForm,
	},
	data() {
		return {
			integerRules: [(v) => (v >= -99999 && v <= 99999) || "値の範囲は-99999〜99999です"],
			floatRules: [(v) => (v >= -999 && v <= 999) || "値の範囲は-999=〜999です"],
			dialog: false,
			valid: false,
			rules: rules,
			common,
			reason: "",
			answer: { status_id: "draft" },
			value: { id: "" },
			answerColumn: {
				data_type: "",
			},
			user: {},
			newValue: "",
			newTargetValue: {
				value_target_id: null,
				value_target_type: null,
				name: "",
			},
			newSynchronizationValue: {
				display_value: null,
				synchronized_data: {},
				new_data: false,
			},
		}
	},
	methods: {
		choiceUpdate() {
			if (this.answer.status_id != "draft") {
				this.createValueFix()
			} else {
				this.updateValue()
			}
		},
		setEditData(dataSet) {
			this.answer = dataSet.answer
			this.value = dataSet.value
			this.answerColumn = dataSet.column
			this.user = dataSet.user
			this.setValue()
			if (this.answerColumn.data_type == "synchronization") this.setValue()
			this.dialog = true
		},
		closeDialog() {
			this.resetForm()
			this.dialog = false
		},
		checkReason() {
			if (this.answer.status_id != "draft" && this.reason == "") {
				this.$store.dispatch("setFlash", {
					text: "理由は必須です",
					type: "alert",
				})
				return
			}
			if (this.newValue == null && this.newTargetValue.id == null) {
				this.$store.dispatch("setFlash", {
					text: "値がありません",
					type: "alert",
				})
				return
			}
		},
		updateValue() {
			this.checkReason()
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			let params = {}
			if (this.answerColumn.data_type == "target") {
				params = {
					new_value: {
						value_target_id: this.newTargetValue.value_target_id,
						value_target_type: this.newTargetValue.value_target_type,
					},
				}
			} else if (this.answerColumn.data_type == "synchronization") {
				if (this.newSynchronizationValue.synchronized_data.skip) {
					this.closeDialog()
					return
				}
				params = {
					new_value: this.newSynchronizationValue.synchronized_data,
					new: this.newSynchronizationValue.new_data,
				}
			} else {
				params = { new_value: this.newValue }
			}
			formData.append("value", JSON.stringify(params))
			axios
				.put("/erp/v1/answer_values/" + this.value.id, formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
					this.dialog = false
					this.resetForm()
					this.$emit("update-answer-values", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		createValueFix() {
			this.checkReason()
			const headers = authenticate.setHeader()
			headers["content-type"] = "multipart/form-data"
			const formData = new FormData()
			let params = {
				value_id: this.value.id,
				reason: this.reason,
			}

			if (this.answerColumn.data_type == "target") {
				params.value_target_id = this.newTargetValue.value_target_id
				params.value_target_type = this.newTargetValue.value_target_type
			} else if (this.answerColumn.data_type == "synchronization") {
				if (this.newSynchronizationValue.synchronized_data.skip) {
					this.closeDialog()
					return
				}
				params.new_value = this.newSynchronizationValue.synchronized_data
				params.new = this.newSynchronizationValue.new_data
			} else {
				params.new_value = this.newValue
			}

			formData.append("valueFix", JSON.stringify(params))
			axios
				.post("/erp/v1/answer_values/fixes", formData, { headers })
				.then((res) => {
					this.$store.dispatch("setFlash", {
						text: "更新しました",
						type: "notice",
					})
					this.dialog = false
					this.resetForm()
					this.$emit("update-answer-values", res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setValue() {
			this.newSynchronizationValue.display_value = common.value(this.answerColumn, this.value.value)
			// draftのパターン
			this.newSynchronizationValue.synchronized_data = this.value.value.synchronized_datum
				? this.value.value.synchronized_datum.draft_data
				: { skip: true }
		},
		synchronizationModelId() {
			return this.value.value?.synchronized_datum
				? this.value.value?.synchronized_datum?.id
				: this.value.value?.model?.id
		},

		resetForm() {
			this.reason = ""
			this.newValue = ""
			this.newTargetValue = {
				value_target_id: null,
				value_target_type: null,
				name: "",
			}
			this.newSynchronizationValue = {
				display_value: null,
				synchronized_data: {},
				new_data: false,
			}
		},
	},
	watch: {},
}
</script>
<style scoped>
.w100 {
	width: 100%;
}
</style>
